import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    component: () => import("@/components/layout/Layout.vue"),
    children: [
      {
        path: "/",
        name: "home",
        component: () => import("@/views/Home.vue"),
        // redirect: "/testchannel",
      },
      {
        path: "/:slug",
        name: "channel-layout",
        component: () => import("@/components/layout/Channel.vue"),
        children: [
          {
            path: "",
            name: "channel",
            component: () => import("@/views/channel/Live.vue"),
          },
          {
            path: "schedules",
            name: "channel-schedules",
            component: () => import("@/views/channel/Calendar.vue"),
          },
          {
            path: "about",
            name: "channel-about",
            component: () => import("@/views/channel/About.vue"),
          },
          {
            path: "programs",
            name: "programs-show",
            component: () => import("@/views/channel/Show.vue"),
          },
        ],
      },
    ],
  },
  {
    path: "/404",
    name: "404",
    component: () => import("@/views/Error404.vue"),
  },
  {
    path: "/:pathMatch(.*)*",
    component: () => import("@/views/Error404.vue"),
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

router.beforeEach(() => {
  // Scroll page to top on every route change
  setTimeout(() => {
    window.scrollTo(0, 0);
  }, 100);
});

export default router;
